import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderRadius,
  borderStyle,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { shadows } from "../../../design-system/tokens/shadows";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${spacing[2]};
  width: 100%;
  min-width: 0;
  min-height: 7.25rem;
  box-sizing: border-box;
  padding: ${spacing[2]};
  color: ${rawColors.text.highEmphasis};
  text-align: left;
  background: ${rawColors.backgroundGradient.storyCreationAi};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.stroke[200]};
  border-radius: ${borderRadius.xl};
  box-shadow: ${shadows.component.card.storyCreationAi};
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${rawColors.stroke[300]};
  }

  &:focus-visible {
    outline: ${borderWidth[2]} ${borderStyle.solid} ${rawColors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Header = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing[1]};
  width: 100%;
  min-width: 0;
`;

export const HeaderIcon = styled.span`
  display: inline-flex;
  width: 1rem;
  height: 1rem;
  flex: 0 0 1rem;
`;

export const Label = styled.span`
  min-width: 0;
  overflow: hidden;
  ${typographyMixin("caption", 3)}
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const IllustrationArea = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 4.625rem;
  flex-shrink: 0;
`;

export const Preview = styled.span`
  position: relative;
  display: block;
  width: 5.0625rem;
  height: 3.25rem;
  flex-shrink: 0;
`;

export const PreviewImage = styled.img`
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
`;

export const PreviewSparkle = styled.img`
  position: absolute;
  top: 0.4375rem;
  left: 2.90625rem;
  display: block;
  width: 0.75rem;
  height: 0.75rem;
`;
